import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import {StateParams} from "../../common";
import {apsEnums} from "../../shared/dto/aps.enums";
import {ICommonQueryingReport} from "./commonQueryingReport";
import {Plant} from "../../models/navigation";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {DefectType} from "../../models/defectType";
import UIUtilityServiceName, {EnumOption, UIUtilityService} from "../../services/utility/uiUtility.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import ReportServiceName, {ReportService} from "../../services/reports/report.service";
import template from './defectsReport.tpl.html';
import DateUtilityService from "../../services/utility/dateutility.service";
import NavigationServiceName, {NavigationService} from "../../services/navigation/navigation.service";
import DefectTypeServiceName, {DefectTypeService} from "../../services/defects/defectType.service";
import {States} from "../../shared/config/constant.module";

let requires = [UIUtilityServiceName, LoaderServiceName, ReportServiceName, NavigationServiceName,
  DefectTypeServiceName];

export interface DefectsReportParams extends StateParams {
  reportPlantId: string;
  reportShopId: string;
  startDate: string;
  endDate: string;
  severity: apsEnums.Severity;
  defectTypeId: string;
  orderBy: apsEnums.DefectOrder;
  showDefectComments: string;
  autoRun: boolean;
}

class DefectsReportCtrl implements ICommonQueryingReport {
  allowErrorCheckForSelectedPlant: boolean;
  plants: Plant[];
  selectedPlant: Plant;
  selectedShop: apsViewModels.ShopNavigation;
  requirePlantSelection: boolean;
  requireShopSelection: boolean;

  startDate: Date;
  endDate: Date;
  uiStartDate: Date;
  uiEndDate: Date;

  defectTypes: DefectType[];
  severities: EnumOption[];
  orderBys: EnumOption[];

  severity: apsEnums.Severity;
  defectTypeId: string;
  orderBy: apsEnums.DefectOrder;
  showDefectComments: boolean;
  displayMaintCheckbox: boolean;
  showMaintCodes: boolean;
  reportStartDate: Date;
  reportEndDate: Date;
  reportShopId: string;
  reportShopName: string;
  reportTimeZoneId: string;
  report: apsViewModels.DefectsReportItem[];
  form: angular.IFormController;

  searchPerformed: boolean;

  private $state: angular.ui.IStateService;
  private $stateParams: DefectsReportParams;
  private $q: angular.IQService;
  private loaderService: LoaderService;
  private reportService: ReportService;
  private uiUtilityService: UIUtilityService;
  private $timeout: angular.ITimeoutService;
  AllPlantsSelected: boolean;

  constructor(
    $state: angular.ui.IStateService,
    $stateParams: DefectsReportParams,
    $q: angular.IQService,
    $timeout: angular.ITimeoutService,
    navigationService: NavigationService,
    reportService: ReportService,
    loaderService: LoaderService,
    uiUtilityService: UIUtilityService,
    defectTypeService: DefectTypeService) {

    var vm = this;
    vm.$state = $state;
    vm.$stateParams = $stateParams;
    vm.loaderService = loaderService;
    vm.reportService = reportService;
    vm.uiUtilityService = uiUtilityService;
    vm.$q = $q;
    vm.$timeout = $timeout;

    vm.requirePlantSelection = true;
    vm.requireShopSelection = true;

    var now = moment().add(1, 'hours').startOf('hour');
    vm.uiEndDate = now.toDate();
    vm.uiStartDate = now.clone().subtract(1, 'days').toDate();

    defectTypeService.getDefectTypesAndClassifications()
      .then((defectTypeData) => vm.defectTypes = defectTypeData.types);

    vm.severities = uiUtilityService.getListOptionsFromEnum(apsEnums.Severity);
    vm.orderBys = uiUtilityService.getListOptionsFromEnum(apsEnums.DefectOrder, 1,6);
    vm.defectTypeId = undefined;
    vm.orderBy = apsEnums.DefectOrder.Time;
    vm.showDefectComments = false;
    vm.showMaintCodes = false;
    vm.displayMaintCheckbox = false;
 
    vm.displayMaintCheckbox = true;
 
    var promise = navigationService.getNavigation().then((nav) => {
      vm.plants = nav.plants();
      vm.selectedPlant = nav.selectedPlant;
      vm.updatePlant();
      vm.selectedShop = nav.selectedShop;

      var option = document.createElement("option");
      option.text = "-- all --";
      option.accessKey = "AllPlants";
      document.getElementById("plantSelectionDropdown").appendChild(option);

      return vm.loadState($stateParams);

    });

    loaderService.loadingPromise(promise);
  }

  loadState(params: DefectsReportParams): angular.IPromise<any> {
    if (params.reportPlantId && params.reportShopId && params.reportShopId !== params.shopId) {
      var plant = _.find(this.plants, {id: params.reportPlantId});
      if (plant) {
        var shop = _.find(plant.shops, {id: params.reportShopId});
        if (shop) {
          this.selectedPlant = plant;
          this.selectedShop = shop;
        }
      }
    }

    DateUtilityService.setReportDates(this, params, this.$timeout);

    if (params.severity !== undefined) {
      var severity = _.find(this.severities, { value: +params.severity }); // !!!
      if (severity) {
        this.severity = severity.value;
      }
    }

    if (params.defectTypeId !== undefined) {
      this.defectTypeId = params.defectTypeId;
    }

    if (params.orderBy !== undefined) {
      var orderBy = _.find(this.orderBys, { value: +params.orderBy }); // !!!
      if (orderBy) {
        this.orderBy = orderBy.value;
      }
    }

    if (params.showDefectComments === 'true') {
      this.showDefectComments = true;
    }
    if (params.autoRun) {
      return this.runReport();
    }

    return this.$q.when();
  }

  saveState() {
    var reportShopId = this.selectedShop ? this.selectedShop.id : undefined;
    if (reportShopId === this.$stateParams.shopId) {
      reportShopId = undefined;
    }
    var params: DefectsReportParams = {
      plantId: this.$stateParams.plantId,
      shopId: this.$stateParams.shopId,
      userId: this.$stateParams.userId,
      reportPlantId: (reportShopId && this.selectedPlant) ? this.selectedPlant.id : undefined,
      reportShopId: reportShopId,
      startDate: this.startDate ? this.startDate.toISOString() : undefined,
      endDate: this.endDate ? this.endDate.toISOString() : undefined,
      defectTypeId: this.defectTypeId,
      severity: this.severity,
      orderBy: this.orderBy,
      showDefectComments: this.showDefectComments.toString(),
      autoRun: true
    };

    this.$state.transitionTo(this.$state.current.name, params);
  }

  private runReport(): angular.IPromise<any> {
    let selectedPlantFromDropdown = (<HTMLInputElement>document.getElementById('plantSelectionDropdown')).value;
    this.reportStartDate = this.startDate;
    this.reportEndDate = this.endDate || new Date();
    
    if (selectedPlantFromDropdown == '-- all --')
    {

      return this.reportService
      .getDefectsReportAll( this.defectTypeId, this.reportStartDate, this.reportEndDate, this.severity)
      .then((report) => {
        this.report = report;        
        this.searchPerformed = true;
      });
    }

    this.reportTimeZoneId = this.selectedPlant.timeZoneId;
    this.reportShopId = this.selectedShop.id;
    this.reportShopName = this.selectedShop.name;


    this.report = null;
    this.searchPerformed = false;
    return this.reportService
      .getDefectsReport(this.reportShopId, this.defectTypeId, this.reportStartDate, this.reportEndDate, this.severity)
      .then((report) => {
        this.report = report;
        this.searchPerformed = true;
      });
  }

  generateReport(): angular.IPromise<any> {
  
    if (this.form.$invalid && ((<HTMLInputElement>document.getElementById('plantSelectionDropdown')).value != '-- all --')) 
    {
      return;
    }

    this.saveState();

    var loadPromise = this.runReport();
    this.loaderService.loadingPromise(loadPromise);
    return loadPromise;
  }

  disableOtherDropdowns(): void
  {
    if ((<HTMLInputElement>document.getElementById('plantSelectionDropdown')).value == '-- all --')
    {
      this.AllPlantsSelected = true;
      this.requireShopSelection = false;
      this.severity = null;
      this.defectTypeId = null;

      if (<HTMLInputElement>document.getElementById('shopDropdown') != null)
      (<HTMLInputElement>document.getElementById('shopDropdown')).disabled=true;
      if (<HTMLInputElement>document.getElementById('severityDropdown') != null)
      (<HTMLInputElement>document.getElementById('severityDropdown')).disabled=true;
      if (<HTMLInputElement>document.getElementById('defectTypeDropdown') != null)
      (<HTMLInputElement>document.getElementById('defectTypeDropdown')).disabled=true;
    }
    else
    {        
      this.AllPlantsSelected = false;
      this.requireShopSelection = true;
      
      if (<HTMLInputElement>document.getElementById('shopDropdown') != null)
      (<HTMLInputElement>document.getElementById('shopDropdown')).disabled=false;
      if (<HTMLInputElement>document.getElementById('severityDropdown') != null)
      (<HTMLInputElement>document.getElementById('severityDropdown')).disabled=false;
      if (<HTMLInputElement>document.getElementById('defectTypeDropdown') != null)
      (<HTMLInputElement>document.getElementById('defectTypeDropdown')).disabled=false;
    }
  }

  getOrderBy(): string[] {
    switch (this.orderBy) {
      case apsEnums.DefectOrder.Time:
        return ['time'];
      case apsEnums.DefectOrder.Severity:
        return ['severity', 'time'];
      case apsEnums.DefectOrder.Location:
        return ['machineName', 'section', 'gob', 'time'];
      case apsEnums.DefectOrder.Mold:
        return ['toolNumber', 'time'];
      case apsEnums.DefectOrder.WhereFound:
        return ['equipmentName', 'time'];
      case apsEnums.DefectOrder.PlantAndShop:
          return ['plantName', 'shopName','time'];
      default:
        return ['time'];
    }
  }

  exportToCsv() {
    let heading = ["Plant Name", "Shop Name", "Date", "Time", "Item", "Defect", "ID", "Machine", "Location", "Mold", "Severity", "MNR", "Frequency", "Where Found", "Found By", "StartTime","EndTime", "Duration"];
    let csv = [];
    csv.push(heading);
    this.report.sort(function(a, b) {
      var timeA = a.time, timeB = b.time;
      if (timeA < timeB) return -1;
      if (timeA > timeB) return 1;
      return 0;
    });
    for(const row of this.report) {
      let rowData = [];
      rowData.push(
        row.plantName,
        row.shopName,
        DateUtilityService.formatDate(row.time, this.reportTimeZoneId),
        DateUtilityService.formatTimeOnly(row.time, this.reportTimeZoneId),
        row.mold + "-" + row.finish,
        row.abbreviation,
        row.legacyId,
        row.machineName,
        row.section ? row.section + row.gobName : '',
        row.toolNumber ? row.toolNumber : '',
        row.severity,
        row.isMoldRejectInUse ? 'Yes' : 'No',
        row.frequencyType === 1
          ? (row.frequencyCount ? row.frequencyCount + ' of ' + row.frequencyTotal  : '')
          : (row.frequencyType === 2 ? row.frequencyPercent + '%' : ''),
        row.equipmentName,
        row.foundBy,
        row.isMoldRejectInUse ? DateUtilityService.formatTimeOnly(row.rejectStart, this.reportTimeZoneId) : '',
        row.isMoldRejectInUse ? DateUtilityService.formatTimeOnly(row.rejectEnd, this.reportTimeZoneId) : '',
        row.isMoldRejectInUse ? row.totalDuration : '',
      );
      csv.push(rowData);
    }
    return csv;
  }

  updatePlant(): void {
    
    if ((<HTMLInputElement>document.getElementById('plantSelectionDropdown')).value == '-- all --')
    {
      this.allowErrorCheckForSelectedPlant = false;
      this.AllPlantsSelected = true;
      this.requireShopSelection = false;
      this.severity = null;
      this.defectTypeId = null;
      
      if (<HTMLInputElement>document.getElementById('shopDropdown') != null)
        (<HTMLInputElement>document.getElementById('shopDropdown')).disabled=true;

      if (<HTMLInputElement>document.getElementById('severityDropdown') != null)
        (<HTMLInputElement>document.getElementById('severityDropdown')).disabled=true;

      if (<HTMLInputElement>document.getElementById('defectTypeDropdown') != null)
        (<HTMLInputElement>document.getElementById('defectTypeDropdown')).disabled=true;
    }
    else
    {
      this.allowErrorCheckForSelectedPlant = false;            
      this.selectedShop = null;
      this.AllPlantsSelected = false;
      this.requireShopSelection = true;

      if (<HTMLInputElement>document.getElementById('shopDropdown') != null)
        (<HTMLInputElement>document.getElementById('shopDropdown')).disabled=false;

      if (<HTMLInputElement>document.getElementById('severityDropdown') != null)
        (<HTMLInputElement>document.getElementById('severityDropdown')).disabled=false;

      if (<HTMLInputElement>document.getElementById('defectTypeDropdown') != null)
        (<HTMLInputElement>document.getElementById('defectTypeDropdown')).disabled=false;
    }
  }

  formatTime(time: Date): string {
    return DateUtilityService.formatTime(time, this.reportTimeZoneId);
  }

  formatToTime(time: Date): string {
    return DateUtilityService.formatTimeOnly(time, this.reportTimeZoneId)
  }
}

export default angular.module('aps.controller.defectsReport', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.DEFECTS_REPORT,
      url: '/admin/reports/defects?startDate&endDate&defectTypeId&severity&orderBy&showDefectComments&autoRun&reportPlantId&reportShopId',
      params: {
        startDate: {dynamic: true},
        endDate: {dynamic: true},
        defectTypeId: {dynamic: true},
        severity: {dynamic: true},
        orderBy: {dynamic: true},
        showDefectComments: {dynamic: true},
        autoRun: {dynamic: true},
        reportPlantId: {dynamic: true},
        reportShopId: {dynamic: true},
      },
      controller: 'DefectsReportCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Defects Report',
        v2Uri: 'aps/reports/defects-report'
      }
    });
  })
  .controller('DefectsReportCtrl', DefectsReportCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/reports/defectsReport.controller.ts